export { default } from './routes/index.js';